import { graphql } from "~/lib/graphql";

export const galleryGridFragment = graphql(`
  fragment galleryGridFragment on GalleryGridRecord {
    __typename
    id
    grid
    imageblock {
      id
      text
      title
      image {
        focalPoint {
          x
          y
        }
        height
        width
        url
        title
        alt
        copyright
        author
        id
        thumbhash
        blurUpThumb
      }
    }
  }
`);
